const UK_COUNTRY_ALIASES = new Set([
  "gb",
  "uk",
  "united kingdom",
  "great britain",
  "england",
  "scotland",
  "wales",
  "northern ireland",
]);

const EXPLICIT_NON_UK_COUNTRY_ALIASES = new Set([
  "ie",
  "ireland",
  "republic of ireland",
]);

export function normalizeCountryLabel(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
}

export function normalizeUkCountry(value) {
  const normalized = normalizeCountryLabel(value);
  if (!normalized || EXPLICIT_NON_UK_COUNTRY_ALIASES.has(normalized)) {
    return null;
  }
  return UK_COUNTRY_ALIASES.has(normalized) ? "GB" : null;
}

export function isUkCountry(value) {
  return normalizeUkCountry(value) === "GB";
}
